var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconParcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7346 17.2578L45.9039 21.9505L17.5992 5.29167L25.6434 0.75L54.7346 17.2578ZM31.4065 29.7761L40.5289 24.8307L12.3596 8.25L3.31268 13.3594L31.4065 29.7761ZM28.8544 34.3178L0.208496 17.5756V46.1902L28.8544 62.5053V34.3178ZM57.5002 49.9036V21.7005L34.0627 34.2604V63.25L57.5002 49.9036ZM41.9819 46.1486L41.0731 46.6669V51.1278L41.9819 50.62V46.1486ZM42.6096 45.789L43.5028 45.2812V49.7526L42.6096 50.2604V45.789ZM45.6409 44.0626L44.7476 44.573V49.0444L45.6409 48.5339V44.0626ZM46.2424 43.7213L47.1356 43.2135V47.6849L46.2424 48.1927V43.7213ZM48.6564 42.3465L47.7476 42.8647V47.3361L48.6564 46.8179V42.3465ZM49.9612 41.6016L50.8544 41.0938V45.5625L50.7138 45.6433L49.9612 46.073V41.6016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParcel);
export default __webpack_public_path__ + "static/media/iconParcel.21dac1ca6adcc88367821206bc534a69.svg";
export { ForwardRef as ReactComponent };